__turbopack_context__.v({
  "activeItem": "euUpEa_activeItem",
  "dropdownInner": "euUpEa_dropdownInner",
  "expand": "euUpEa_expand",
  "expanded": "euUpEa_expanded",
  "expandedContainer": "euUpEa_expandedContainer",
  "icon": "euUpEa_icon",
  "inlineDropdownNav": "euUpEa_inlineDropdownNav",
  "item": "euUpEa_item",
  "label": "euUpEa_label",
  "labelIcon": "euUpEa_labelIcon",
  "options": "euUpEa_options",
  "scroll": "euUpEa_scroll",
  "select": "euUpEa_select",
});
